import React from "react";
import {
  BackgroundProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  SpaceProps,
} from "styled-system";
import { Flex } from "../Flex";

export const Card: React.FC<
  SpaceProps & ColorProps & BackgroundProps & LayoutProps & FlexboxProps
> = props => {
  const { children } = props;
  return (
    <Flex {...props} borderRadius={5}>
      {children}
    </Flex>
  );
};

Card.defaultProps = {
  backgroundSize: "cover",
  bg: "primary",
};
